package org.example.project.yard

import androidx.compose.runtime.Composable
import org.example.project.enginetabular.TabularScreen
import org.example.project.enginetabular.TabularSelectionMode
import org.example.project.utils.All

@Composable
fun YardAktivitaetsfeedTable(
    screenKey: String,
    rollenKey: String,
    aktivitaetsFeed: List<All>,
    onSearchWithFilters: ((Map<String, String>) -> Unit)? = null
) {
    TabularScreen(
        screenKey = screenKey,
        rollenKey = rollenKey,
        title = "Infofeed",
        headers = listOf("Uhrzeit", "TYP", "LS NUMMER", "EVENT"),
        data = aktivitaetsFeed.mapIndexed { index, entry ->
            (entry.id.ifBlank { "aktivitaet_$index" }) to listOf(
                yardAktivitaetsfeedUhrzeit(entry),
                yardAktivitaetsfeedTyp(entry),
                yardAktivitaetsfeedLsNummer(entry),
                yardAktivitaetsfeedEvent(entry)
            )
        },
        onCommit = {},
        editable = false,
        hardReadOnly = true,
        selectionMode = TabularSelectionMode.ROWS,
        allowCreate = false,
        allowSave = false,
        allowDelete = false,
        allowImportButton = false,
        allowExportButton = true,
        allowSettingsButton = false,
        allowRefreshButton = false,
        showToolbarExtras = false,
        showFilterRow = true,
        onSearchWithFilters = onSearchWithFilters,
        includeMetadata = false
    )
}

private fun yardAktivitaetsfeedLsNummer(entry: All): String =
    entry.feedLsNummer

private fun yardAktivitaetsfeedTyp(entry: All): String =
    entry.feedArt

private fun yardAktivitaetsfeedEvent(entry: All): String =
    entry.feedEvent
        .removeSuffix(entry.feedLsNummer)
        .trim()

private fun yardAktivitaetsfeedUhrzeit(entry: All): String =
    entry.feedUhrzeit
